export default __webpack_public_path__ + "static/media/lunch6.ee674da7.png";